export default "__VITE_ASSET__BlaTaIIq__"